import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BriefType, FactRead } from './molecules/conversation/smart-brief-conversation';

@Injectable({ providedIn: 'root' })
export class SmartBriefExtractService {
  private readonly http = inject(HttpClient);

  extract(body: {
    text?: string;
    instruction?: string;
    current?: FactRead;
    briefType?: BriefType;
  }): Observable<FactRead> {
    return this.http.post<FactRead>(`${environment.shout_api.url}/briefs/extract`, body);
  }

  readFile(body: { fileKey?: string; fileName?: string; url?: string }): Observable<BriefFileTextResponse> {
    return this.http.post<BriefFileTextResponse>(`${environment.shout_api.url}/briefs/file-text`, body);
  }

  readGoogleDoc(body: { url: string }): Observable<GoogleDocTextResponse> {
    return this.http.post<GoogleDocTextResponse>(`${environment.shout_api.url}/briefs/google-doc-text`, body);
  }
}

export type BriefFileTextResponse = {
  outcome: 'text' | 'empty' | 'unreadable';
  text: string;
  fileName: string;
  fileUrl: string;
  fileKey: string;
};

export type GoogleDocTextResponse = {
  outcome: 'text' | 'empty' | 'unreadable';
  text: string;
  title: string;
  documentUrl: string;
};
